// @ts-ignore
/* eslint-disable */
import request from "../../request";

/** 手机端通过令牌上传文件（公开接口） POST /apiAdmin/file/cross-upload/${param0} */
export async function fileControllerCrossUploadFile(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.FileControllerCrossUploadFileParams,
  body: {},
  file?: File,
  options?: { [key: string]: any }
) {
  const { token: param0, ...queryParams } = params;
  const formData = new FormData();

  if (file) {
    formData.append("file", file);
  }

  Object.keys(body).forEach((ele) => {
    const item = (body as any)[ele];

    if (item !== undefined && item !== null) {
      if (typeof item === "object" && !(item instanceof File)) {
        if (item instanceof Array) {
          item.forEach((f) => formData.append(ele, f || ""));
        } else {
          formData.append(
            ele,
            new Blob([JSON.stringify(item)], { type: "application/json" })
          );
        }
      } else {
        formData.append(ele, item);
      }
    }
  });

  return request<API.ResultDataObjectDto>(
    `/apiAdmin/file/cross-upload/${param0}`,
    {
      method: "POST",
      params: { ...queryParams },
      data: formData,
      requestType: "form",
      ...(options || {}),
    }
  );
}

/** 查询跨端上传状态（公开接口，PC端轮询） GET /apiAdmin/file/cross-upload/status/${param0} */
export async function fileControllerGetCrossUploadStatus(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.FileControllerGetCrossUploadStatusParams,
  options?: { [key: string]: any }
) {
  const { token: param0, ...queryParams } = params;
  return request<API.ResultDataObjectDto>(
    `/apiAdmin/file/cross-upload/status/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 创建跨端上传令牌（PC端调用） POST /apiAdmin/file/cross-upload/token */
export async function fileControllerCreateCrossUploadToken(options?: {
  [key: string]: any;
}) {
  return request<API.ResultDataObjectDto>("/apiAdmin/file/cross-upload/token", {
    method: "POST",
    ...(options || {}),
  });
}

/** 删除文件 DELETE /apiAdmin/file/delete */
export async function fileControllerDeleteFile(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.FileControllerDeleteFileParams,
  options?: { [key: string]: any }
) {
  return request<any>("/apiAdmin/file/delete", {
    method: "DELETE",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取文件详情 GET /apiAdmin/file/detail */
export async function fileControllerGetFileDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.FileControllerGetFileDetailParams,
  options?: { [key: string]: any }
) {
  return request<API.ResultDataFileInfoDtoDto>("/apiAdmin/file/detail", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取图片（公开接口，重定向到 COS） GET /apiAdmin/file/image/${param0} */
export async function fileControllerGetImage(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.FileControllerGetImageParams,
  options?: { [key: string]: any }
) {
  const { path: param0, ...queryParams } = params;
  return request<any>(`/apiAdmin/file/image/${param0}`, {
    method: "GET",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 获取文件列表 POST /apiAdmin/file/list */
export async function fileControllerGetFileList(
  body: API.QueryFileListDto,
  options?: { [key: string]: any }
) {
  return request<API.ResultDataFileInfoDtoArrayDto>("/apiAdmin/file/list", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 更新文件信息 PUT /apiAdmin/file/update */
export async function fileControllerUpdateFile(
  body: API.UpdateFileDto,
  options?: { [key: string]: any }
) {
  return request<any>("/apiAdmin/file/update", {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 上传文件 POST /apiAdmin/file/upload */
export async function fileControllerUploadFile(
  body: {
    /** 业务类型 */
    bizType: string;
    /** 业务ID */
    bizId: number;
    /** 文件类型（字典值） */
    fileType?: string;
    /** 备注 */
    remark?: string;
  },
  file?: File,
  options?: { [key: string]: any }
) {
  const formData = new FormData();

  if (file) {
    formData.append("file", file);
  }

  Object.keys(body).forEach((ele) => {
    const item = (body as any)[ele];

    if (item !== undefined && item !== null) {
      if (typeof item === "object" && !(item instanceof File)) {
        if (item instanceof Array) {
          item.forEach((f) => formData.append(ele, f || ""));
        } else {
          formData.append(
            ele,
            new Blob([JSON.stringify(item)], { type: "application/json" })
          );
        }
      } else {
        formData.append(ele, item);
      }
    }
  });

  return request<API.ResultDataFileInfoDtoDto>("/apiAdmin/file/upload", {
    method: "POST",
    data: formData,
    requestType: "form",
    ...(options || {}),
  });
}

/** 上传临时文件（不存档，上传到 template/ 目录，COS 自动过期清理） POST /apiAdmin/file/upload-temp */
export async function fileControllerUploadTempFile(
  body: {},
  file?: File,
  options?: { [key: string]: any }
) {
  const formData = new FormData();

  if (file) {
    formData.append("file", file);
  }

  Object.keys(body).forEach((ele) => {
    const item = (body as any)[ele];

    if (item !== undefined && item !== null) {
      if (typeof item === "object" && !(item instanceof File)) {
        if (item instanceof Array) {
          item.forEach((f) => formData.append(ele, f || ""));
        } else {
          formData.append(
            ele,
            new Blob([JSON.stringify(item)], { type: "application/json" })
          );
        }
      } else {
        formData.append(ele, item);
      }
    }
  });

  return request<API.ResultDataObjectDto>("/apiAdmin/file/upload-temp", {
    method: "POST",
    data: formData,
    requestType: "form",
    ...(options || {}),
  });
}
